const UNKNOWN_REFERENCE_PATTERN = /\[([A-Z0-9_]+(?:#[A-Z])?)\]/gi;

function normalizeName(name) {
  return name.toUpperCase();
}

function createReferenceEntry(name) {
  return {
    name,
    count: 0,
    appearances: [],
  };
}

function extractUnknownReferences(node) {
  const references = [];
  let match;

  UNKNOWN_REFERENCE_PATTERN.lastIndex = 0;

  while ((match = UNKNOWN_REFERENCE_PATTERN.exec(node.raw)) !== null) {
    references.push({
      name: match[1],
      token: match[0],
      index: match.index,
    });
  }

  return references;
}

export function generateUnknownReferenceFrequencyReport(ast) {
  const unhandledFrequencies = {};
  const visualFrequencies = {};
  let windowDepth = 0;
  let menuDepth = 0;

  const addReferences = (frequencies, node) => {
      extractUnknownReferences(node).forEach((reference) => {
        const key = normalizeName(reference.name);

        if (!frequencies[key]) {
          frequencies[key] = createReferenceEntry(reference.name);
        }

        frequencies[key].count += 1;
        frequencies[key].appearances.push({
          line: node.line,
          token: reference.token,
          index: reference.index,
          raw: node.raw,
        });
      });
  };

  (ast.nodes || []).forEach((node) => {
    if (node.type === 'window') windowDepth += 1;
    if (node.type === 'menu') menuDepth += 1;

    if (node.type === 'unknown' && node.raw) {
      addReferences(windowDepth > 0 || menuDepth > 0 ? visualFrequencies : unhandledFrequencies, node);
    }

    if (node.type === 'endwindow') windowDepth = Math.max(0, windowDepth - 1);
    if (node.type === 'endmenu') menuDepth = Math.max(0, menuDepth - 1);
  });

  const summarize = (frequencies) => ({
    totalReferences: Object.values(frequencies).reduce((total, item) => total + item.count, 0),
    variables: Object.values(frequencies).sort((left, right) => {
      if (right.count !== left.count) return right.count - left.count;
      return left.name.localeCompare(right.name);
    }),
  });

  const unhandled = summarize(unhandledFrequencies);
  const visual = summarize(visualFrequencies);

  return {
    totalReferences: unhandled.totalReferences,
    variables: unhandled.variables,
    unhandled,
    visual,
  };
}
